const SITE_ORIGIN = "https://scoopulator.app";

export function getCanonicalUrl(pathname: string): string {
  const canonicalUrl = new URL(SITE_ORIGIN);

  canonicalUrl.pathname =
    pathname === "/" ? pathname : pathname.replace(/\/+$/, "");

  return canonicalUrl.toString();
}
